import { render, staticRenderFns } from "./BBBLogo.vue?vue&type=template&id=5835c99e&"
import script from "./BBBLogo.vue?vue&type=script&lang=js&"
export * from "./BBBLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports